<template>
  <img
    :key="frente"
    :src="frente"
    alt="Frente do certificado"
    class="bg-image"
  />
</template>

<script setup>
import { appStore } from "@/store";
import { computed } from "vue";
import "./../assets/base/front.png";
import "./../assets/base/front-nr-10.png";

const training = computed(() => appStore.getters.getTrainingSelected);
const frente = computed(() => {
  if (training.value.value == "NR 10")
    return require(`./../assets/base/front.png`);

  if (training.value.value == "NR 18")
    return require(`./../assets/base/front.png`);

  if (training.value.value == "BRIGADA PS")
    return require(`./../assets/base/front.png`);

  if (training.value.value == "NR 18 SIN")
    return require(`./../assets/base/front.png`);

  return require(`./../assets/base/front.png`);
});
</script>

<style scoped>
.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
</style>
